import AppConstants from '../config/app.constants';

let LocationZoneService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/location-zone`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data;
            })
    };

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/location-zone/${id}`)
            .then((res) => {
                return res.data;
            })
    }

    let remove = (id, name, description, branchId) => {
        return $http
            .delete(AppConstants.api + `/location-zone/${id}`, {
                params: {
                    id, name, description, branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/location-zone/create`, { data })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/location-zone/${id}/update`, { data })
            .then((res) => {
                return res.data;
            })
    };

    return {
        all,
        get,
        remove,
        create,
        update
    };
};

LocationZoneService.$inject = ['$http', '$q'];

export default LocationZoneService;


// WEBPACK FOOTER //
// ./client/app/services/location-zone.service.js